import {createFileRoute} from '@tanstack/react-router'

import BehaviorScreen from '@protected/behavior'

export const Route = createFileRoute('/_protected/behavior')({component: BehaviorScreen})
